import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import { loadStore } from "store";
var LoginView = /** @class */ (function (_super) {
    tslib_1.__extends(LoginView, _super);
    function LoginView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //loading = true;
        _this.email = "";
        _this.firstName = "";
        _this.lastName = "";
        _this.company = "";
        _this.errorMessage = "";
        return _this;
    }
    Object.defineProperty(LoginView.prototype, "registerDisabled", {
        // countries: any[]= null;
        // selectedCountryId: number = 53;
        //registerDisabled = true;
        get: function () {
            if (!this.email || !this.firstName || !this.lastName || !this.company)
                return true;
            var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return !pattern.test(this.email);
        },
        enumerable: true,
        configurable: true
    });
    // mounted() {
    //     this.getCountries();
    // }
    // async getCountries() {
    //     this.countries = (await axios.get("user/countries")).data;
    //     this.loading = false;
    // }
    LoginView.prototype.register = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post("user/register", {
                            firstName: this.firstName,
                            lastName: this.lastName,
                            endCustomerName: this.company,
                            /*endCustomerRegionId: this.selectedCountryId, */
                            email: this.email
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        if (!!data) return [3 /*break*/, 2];
                        this.errorMessage = this.$t("registerUserView.alreadyRegistered").toString();
                        return [3 /*break*/, 4];
                    case 2:
                        localStorage.setItem("sessionToken", data);
                        return [4 /*yield*/, loadStore()];
                    case 3:
                        _a.sent();
                        this.$router.push("/");
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoginView = tslib_1.__decorate([
        Component
    ], LoginView);
    return LoginView;
}(Vue));
export default LoginView;
